import { render, staticRenderFns } from "./selfCompanyShipmentForm.vue?vue&type=template&id=66857773&scoped=true"
import script from "./selfCompanyShipmentForm.vue?vue&type=script&lang=js"
export * from "./selfCompanyShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./selfCompanyShipmentForm.vue?vue&type=style&index=0&id=66857773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66857773",
  null
  
)

export default component.exports